// import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { useState } from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';

/*const images = [
  {
    original: 'https://picsum.photos/id/1018/1000/600/',
    thumbnail: 'https://picsum.photos/id/1018/1000/600/',
    showFullscreenButton: true
  },
  {
    original: 'https://picsum.photos/id/1015/1000/600/',
    thumbnail: 'https://picsum.photos/id/1015/1000/600/',
    showFullscreenButton: true
  },
  {
    original: 'https://picsum.photos/id/1019/1000/600/',
    thumbnail: 'https://picsum.photos/id/1019/1000/600/',
    showFullscreenButton: true
  },
  {
    original: 'https://picsum.photos/id/1018/1000/600/',
    thumbnail: 'https://picsum.photos/id/1018/1000/600/',
    showFullscreenButton: true
  },
  {
    original: 'https://picsum.photos/id/1015/1000/600/',
    thumbnail: 'https://picsum.photos/id/1015/1000/600/',
    showFullscreenButton: true
  },
  {
    original: 'https://picsum.photos/id/1019/1000/600/',
    thumbnail: 'https://picsum.photos/id/1019/1000/600/',
    showFullscreenButton: true
  },
  {
    original: 'https://picsum.photos/id/1018/1000/600/',
    thumbnail: 'https://picsum.photos/id/1018/1000/600/',
    showFullscreenButton: true
  },
  {
    original: 'https://picsum.photos/id/1015/1000/600/',
    thumbnail: 'https://picsum.photos/id/1015/1000/600/',
    showFullscreenButton: true
  },
  {
    original: 'https://picsum.photos/id/1019/1000/600/',
    thumbnail: 'https://picsum.photos/id/1019/1000/600/',
    showFullscreenButton: true
  },
  {
    original: 'https://picsum.photos/id/1018/1000/600/',
    thumbnail: 'https://picsum.photos/id/1018/1000/600/',
    showFullscreenButton: true
  },
  {
    original: 'https://picsum.photos/id/1015/1000/600/',
    thumbnail: 'https://picsum.photos/id/1015/1000/600/',
    showFullscreenButton: true
  },
  {
    original: 'https://picsum.photos/id/1019/1000/600/',
    thumbnail: 'https://picsum.photos/id/1019/1000/600/',
    showFullscreenButton: true
  }
];*/

const MachineImageGallery = ({ galleryImgArr }) => {
  const [images, setImages] = useState([]);
  useEffect(() => {
    if (galleryImgArr) {
      const imagesArr = galleryImgArr.map((image) => ({
        original: image?.url || '',
        thumbnail: image?.url || '',
        showFullscreenButton: true
      }));
      setImages(imagesArr);
    }
  }, [galleryImgArr]);

  return (
    // <Grid container spacing={5} className="justify-center">
    //   <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
    <ImageGallery
      items={images}
      autoPlay={true}
      showIndex={true}
      showBullets={true}
      lazyLoad={true}
      showPlayButton={true}

      // thumbnailPosition={'left'}
    />
    //   </Grid>
    // </Grid>
  );
};

export default MachineImageGallery;
